import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, CircularProgress, Alert } from "@mui/material";
import axios from "axios";
import Helpers from "../Config/Helpers";
import AddReceipts from "./AddReceipts";

function EditReceipt() {
  const { receiptId } = useParams();
  const navigate = useNavigate();
  const [receipt, setReceipt] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    setReceipt(null);
    setError("");
    axios.get(`${Helpers.baseUrl}/receipts/details/${receiptId}`, Helpers.headers)
      .then(({ data }) => { if (active) setReceipt(data); })
      .catch((failure) => {
        if (!active) return;
        Helpers.unauthenticated(failure, navigate);
        setError(failure.response?.data?.error || "Could not load this receipt");
      });
    return () => { active = false; };
  }, [receiptId, navigate]);
  if (!receipt) return <Box sx={{ pt: 12, px: 4 }}>{error ? <Alert severity="error">{error}</Alert> : <CircularProgress />}</Box>;
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  const path = receipt.receiptType === "Invoice" ? "/user/receipts" : "/user/estimates";
  const canEdit = !Helpers.authUser?.user_role || permissions.some((permission) =>
    permission.tab_link === path && String(permission.can_update) === "1");
  if (!canEdit) return <Box sx={{ pt: 12, px: 4 }}><Alert severity="error">You do not have permission to edit this receipt.</Alert></Box>;
  return <AddReceipts key={receiptId} receiptToEdit={receipt} />;
}

export default EditReceipt;
